import UserApiBase from "../base/UserApiBase";

import {
  type PaginatedRequest,
  type PaginatedResponse,
} from "@/schemas/api/pagination";
import { type AppUserSession } from "@/schemas/auth/session";
import {
  RelationshipType,
  type UserRelationship,
} from "@/schemas/user/relationship";

class RelationshipService extends UserApiBase {
  public constructor(session: AppUserSession) {
    super("/relationship", session);
  }

  public getRelationships(
    target: string,
    type: RelationshipType,
    page: PaginatedRequest,
  ): Promise<PaginatedResponse<UserRelationship>> {
    const paginateQueryStr = this.buildPaginateQueryStr(page);
    return this.get(`/${target}/${type}${paginateQueryStr}`);
  }

  public toFollow(target: string): Promise<void> {
    return this.post(`/follow/${target}`, {});
  }

  public toUnFollow(target: string): Promise<void> {
    return this.post(`/unfollow/${target}`, {});
  }

  public toFollowOrNot(isFollowing: boolean, target: string): Promise<void> {
    if (isFollowing) {
      return this.toUnFollow(target);
    } else {
      return this.toFollow(target);
    }
  }
}

export default RelationshipService;
